import React from 'react';
import { CheckIcon, DropletsIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach water systems with confidence starting today'];
export function FinalCta() {
  return <section className="bg-stage water-glow py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jbtw9kxvkob6">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1ed8xlpy9ucou">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-silver" data-id="element-72" data-mp="1t2on72m2gc2y">
          <DropletsIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o3lffaepbrra" /> {productName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="22338w32xzt6z">
          Created by water science specialists, for educators worldwide
        </h2>

        <Countdown className="mt-8" data-id="element-75" data-mp="n6e47joasdvb" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-silver/40 bg-navyPanel p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n7fcxhhuco9v">
          <p data-id="element-77" data-mp="x2qxwhjuerq2">
            <b className="block text-sm uppercase leading-tight text-silverBright" data-id="element-78" data-mp="x27d8t2t5p8c">{productName}</b>
            <span className="text-sm text-silver" data-id="element-79" data-mp="124g67pfokrag">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="1b31pxnww2cct">
            <p className="text-sm text-silver" data-id="element-81" data-mp="1b1qk7ijvuuj2">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1ftqeaud9ut7q">{priceBefore}</span>
              <b className="text-base text-silverBright" data-id="element-83" data-mp="1fwmc8ip4dhw6">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1ksl4ihdkjk1v">
              Get my collection now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-silverDark" data-id="element-85" data-mp="1tuay9tuxav2t">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3lw44rha3teaz">
              <CheckIcon className="h-4 w-4 text-silver" aria-hidden="true" data-id="element-87" data-mp="3hl576c54cc3" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}